module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (52).5fda6180.jpg";